import { appColors, Tier } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { MarkersOfSuccessExpandableGroup } from '@backrs_ui/grow-ui/src/components/MarkersOfSuccess/MarkersOfSuccessExpandableGroup';
import { SchoolLevel } from '@backrs_ui/grow-ui/src/models/models';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { ResultsPill } from './ResultsPill';

const MARKERS_OF_SUCCESS_STRINGS = appStrings.modules.results;

type ExpandableSuccessItemsProps = Readonly<{
  tier: Tier;
  schoolLevel: SchoolLevel;
  expandedMarkersOfSuccessIndex: number | null;
}>;

export const ExpandableSuccessItems = ({
  tier,
  schoolLevel,
  expandedMarkersOfSuccessIndex,
}: ExpandableSuccessItemsProps) => {
  return (
    <Box sx={expandableSuccessItemsStyle}>
      <Box sx={pillAndDescriptionContainerStyle}>
        <Box width="100%">
          <ResultsPill title={MARKERS_OF_SUCCESS_STRINGS.markersOfSuccessSectionTitle} />
        </Box>
        <Typography variant="body1" sx={sectionDescriptionStyle}>
          {MARKERS_OF_SUCCESS_STRINGS.sectionDescriptions.markersOfSuccess(tier, schoolLevel)}
        </Typography>
      </Box>
      <MarkersOfSuccessExpandableGroup
        tier={tier}
        schoolLevel={schoolLevel}
        expandedMarkersOfSuccessIndex={expandedMarkersOfSuccessIndex}
      />
    </Box>
  );
};

const sectionDescriptionStyle: SxProps<Theme> = {
  fontStyle: 'italic',
  fontSize: '14px',
  lineHeight: '1.25',
};

const expandableSuccessItemsStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  border: `2px solid ${appColors.neutral.black}`,
  borderRadius: '.5rem',
  paddingX: {
    xs: '1rem',
    sm: '2rem',
  },
  paddingY: '2rem',
};

const pillAndDescriptionContainerStyle: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
  flexDirection: {
    xs: 'column',
    sm: 'column',
    md: 'row',
  },
};
